import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Results.css';

const Results = () => {
  const location = useLocation();
  const preferences = location.state?.preferences || {
    aspiration: 'Technology & Software',
    experienceLevel: 'intermediate',
    timeCommitment: 8
  };

  const { aspiration, experienceLevel, timeCommitment } = preferences;

  const generateRoadmap = (pref) => {
    const roadmap = [];

    // Foundational Content
    if (pref.experienceLevel === 'beginner') {
      roadmap.push({
        title: `Foundations of ${pref.aspiration}`,
        description: 'Start here: A beginner’s course covering core terminology and concepts. (Video series)',
        duration: '4 hours'
      });
    } else {
      roadmap.push({
        title: `Advanced Concepts in ${pref.aspiration}`,
        description: 'Skip the basics: Deep dive into current trends and expert tooling. (Article bundle)',
        duration: '2 hours'
      });
    }

    // Project Content
    if (pref.timeCommitment >= 10) {
      roadmap.push({
        title: 'High-Commitment Capstone Project',
        description: 'Recommended: A large, real-world project to solidify skills (3-week commitment).',
        duration: '15 hours'
      });
    } else {
      roadmap.push({
        title: 'Quick Skill Builder Project',
        description: 'Recommended: A small, focused project that can be completed in a few sessions.',
        duration: '5 hours'
      });
    }

    // Next Action
    roadmap.push({
      title: 'Your Next Actionable Step',
      description: `Based on your ${pref.timeCommitment} hours/week commitment, focus on completing the first module of the foundational course.`,
      duration: '2 hours'
    });

    return roadmap;
  };

  const roadmapSteps = generateRoadmap(preferences);

  return (
    <div className="results-page section-padding">
      <div className="results-header main-content">
        <h1 className="section-heading">Your Personalized Roadmap is Ready!</h1>
        <p className="results-subtext">
          We used your <strong>{aspiration}</strong> aspiration, <strong>{experienceLevel}</strong> experience, and <strong>{timeCommitment} hours/week</strong> commitment to filter thousands of resources.
        </p>
      </div>

      <div className="roadmap-container main-content">
        <h3 className="roadmap-title">Priority Learning Path</h3>

        <div className="roadmap-grid">
          {roadmapSteps.map((step, index) => (
            <div key={index} className="roadmap-card glossy-card">
              <div className="step-number-badge">{index + 1}</div>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
              <span className="duration-tag">Est. {step.duration}</span>
            </div>
          ))}
        </div>

        <div className="results-cta-wrapper">
          <p>Unlock the full library and save your progress.</p>
          <Link to="/signup" className="btn-primary">
            Create Your Free Account and Save
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Results;
